import gql from 'graphql-tag';
import { PROJECT_BANK_ATTACHMENT_SELECTION } from './projectBankAttachmentSelection';

/**
 * Data of the block project-bank-self-disclosure ("Selbstauskunft", tab Bank): the bank attachments of its types. Read through
 * `Project.blocks.bankSelfDisclosure`, which checks the block's read permission.
 */
export const PROJECT_BANK_SELF_DISCLOSURE_FIELDS = gql`
  fragment projectBankSelfDisclosureFields on ProjectBankSelfDisclosureBlock {
    id
    number
    bank {
      ${PROJECT_BANK_ATTACHMENT_SELECTION}
    }
  }
`;
